// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const threadClient = createTypedClient();
export const createThreadClient = (config) => createTypedClient(config);
